var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDealLostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0.356445C14.0388 0.356445 10.6554 1.37923 7.77753 3.29547C4.89967 5.21171 2.65665 7.93533 1.33212 11.1219C0.00758246 14.3085 -0.338976 17.8149 0.336265 21.1978C1.01151 24.5806 2.67822 27.688 5.12564 30.1269C7.57306 32.5658 10.6913 34.2267 14.0859 34.8996C17.4806 35.5725 20.9993 35.2272 24.197 33.9072C27.3947 32.5873 30.1278 30.3521 32.0507 27.4842C33.9737 24.6164 35 21.2447 35 17.7956C34.9948 13.172 33.1494 8.73934 29.8686 5.47C26.5878 2.20066 22.1397 0.361655 17.5 0.356445ZM17.5 32.7434C13.5218 32.7434 9.70645 31.1685 6.89341 28.3653C4.08036 25.562 2.50001 21.76 2.50001 17.7956C2.50001 13.8312 4.08036 10.0291 6.89341 7.22587C9.70645 4.42261 13.5218 2.84775 17.5 2.84775V17.7956L28.1015 28.3605C26.7112 29.7508 25.0589 30.8538 23.2396 31.6059C21.4202 32.3581 19.4697 32.7446 17.5 32.7434Z",
    fill: "#EE6C4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealLostIcon);
export default __webpack_public_path__ + "static/media/Deal-Lost-Icon.6a8346d8a0f4fc78538d24fe247d7917.svg";
export { ForwardRef as ReactComponent };